/**
 * Takes in strings such as: "Show on Desktop, hide on mobile" and returns the
 * appropriate tailwindcss visibility class. The param is called itemDisplay
 * because that's what the setting is called in contentstack.
 */
export function getVisibilityFilter(itemDisplay) {
  const handleizeDisplayOption = (value) => {
    return value?.replace(',', '').replace(/ /g, '-').toLowerCase();
  };

  const handle = handleizeDisplayOption(itemDisplay);
  if (handle.includes('hide-on-desktop')) {
    return 'lg:hidden';
  } else if (handle.includes('hide-on-mobile')) {
    return 'hidden lg:block';
  } else {
    return 'block';
  }
}
